const howData = [
    {id:1,
    title:"Sign in",
    info: "Lorem ipsum dolor sit amet"
},

{
    id:2,
    title:"Send payment request",
    info:"Lorem ipsum dolor sit amet"
},
{
    id:3,
    title:"Send Payment Request",
    info:"Lorem ipsum dolor sit amet"
}
]

export default howData;